/* eslint-disable complexity */
import { Breadcrumbs } from "../../../../../../../../constant/Breadcrumbs"
import { Routers } from "../../../../../../../../constant/Routers"

const { SCR210, SCR210_TRAVELERS } = Routers
const {
  BRCR_SCR215_FROM_SCR214_AND_SCR210_TRAVELERS,
  BRCR_SCR215_FROM_SCR214_AND_SCR210,
  BRCR_SCR215_FROM_SCR214_AND_SCR211_TRAVELERS,
  BRCR_SCR215_FROM_SCR214_AND_SCR211,
  BRCR_SCR215,
} = Breadcrumbs

export const getBreadcrumbItems = (
  schedulesURL?: string,
  isFromSCR210?: boolean,
  isFromSCR211?: boolean,
  isFromSCR214?: boolean,
) => {
  if (isFromSCR210 && isFromSCR214) {
    if (!isFromSCR211) {
      if (schedulesURL === SCR210) return BRCR_SCR215_FROM_SCR214_AND_SCR210

      if (schedulesURL === SCR210_TRAVELERS)
        return BRCR_SCR215_FROM_SCR214_AND_SCR210_TRAVELERS

      return BRCR_SCR215
    }

    if (isFromSCR211) {
      if (schedulesURL === SCR210) return BRCR_SCR215_FROM_SCR214_AND_SCR211

      if (schedulesURL === SCR210_TRAVELERS)
        return BRCR_SCR215_FROM_SCR214_AND_SCR211_TRAVELERS

      return BRCR_SCR215
    }

    return BRCR_SCR215
  }

  return BRCR_SCR215
}
